function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons-/-ic_chevron-/-Grey-down",
  fill: "#9F9AAD"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,9.65758773 L12.6399996,5.10894995 C12.7822225,4.96368335 12.9244433,4.96368335 13.0666662,5.10894995 L13.8933328,5.92607051 C14.0355557,6.07133712 14.0355557,6.21660154 13.8933328,6.36186814 L8.21333331,11.9182879 C8.15999972,11.9727629 8.08888933,12 8,12 C7.91111067,12 7.84000028,11.9727629 7.78666669,11.9182879 L2.10666719,6.36186814 C1.96444427,6.21660154 1.96444427,6.07133712 2.10666719,5.92607051 L2.93333378,5.10894995 C3.0755567,4.96368335 3.21777749,4.96368335 3.36000041,5.10894995 L8,9.65758773 Z",
  id: "ic_chevron-/-Grey-down"
})));

function SvgGreyDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyDown);
export default __webpack_public_path__ + "static/media/grey-down.7e619a7a.svg";
export { ForwardRef as ReactComponent };